import * as betprofessor from './PrimaryLayout.styles.betprofessor';
import * as betroyale from './PrimaryLayout.styles.betroyale';
import * as fiestabet from './PrimaryLayout.styles.fiestabet';
import * as puntcity from './PrimaryLayout.styles.puntcity';
import * as puntgenie from './PrimaryLayout.styles.puntgenie';
import * as questbet from './PrimaryLayout.styles.questbet';
import * as sterlingparker from './PrimaryLayout.styles.sterlingparker';
import * as vikingbet from './PrimaryLayout.styles.vikingbet';
import * as volcanobet from './PrimaryLayout.styles.volcanobet';
import * as wellbet from './PrimaryLayout.styles.wellbet';
import * as juicybet from './PrimaryLayout.styles.juicybet';
import * as goldenrush from './PrimaryLayout.styles.goldenrush';
import * as forsport from './PrimaryLayout.styles.forsport';
import * as junglebet from './PrimaryLayout.styles.junglebet';
import * as betstride from './PrimaryLayout.styles.betstride';
import * as oldgill from './PrimaryLayout.styles.oldgill';
import * as sugarcastle from './PrimaryLayout.styles.sugarcastle';
import * as betgalaxy from './PrimaryLayout.styles.betgalaxy';
import * as titanbet from './PrimaryLayout.styles.titanbet';
import * as templebet from './PrimaryLayout.styles.templebet';
import * as gigabet from './PrimaryLayout.styles.gigabet';
import * as slambet from './PrimaryLayout.styles.slambet';
import * as betbetbet from './PrimaryLayout.styles.betbetbet';
import * as goldenbet888 from './PrimaryLayout.styles.goldenbet888';
import * as chromabet from './PrimaryLayout.styles.chromabet';
import * as hyperbet from './PrimaryLayout.styles.hyperbet';
import * as bet777 from './PrimaryLayout.styles.bet777';
import * as epicodds from './PrimaryLayout.styles.epicodds';
import * as bet575 from './PrimaryLayout.styles.bet575';
import * as magnumbet from './PrimaryLayout.styles.magnumbet';
import * as pyramidbet from './PrimaryLayout.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  titanbet,
  templebet,
  gigabet,
  slambet,
  betstride,
  betbetbet,
  goldenbet888,
  chromabet,
  hyperbet,
  bet777,
  epicodds,
  bet575,
  magnumbet,
  pyramidbet,
};
